function initClickableOverviewItems() {
	const overviews = Array.from(document.querySelectorAll('.Grid.Overview, .News.Overview.default, .Search.Overview, .Vacancy.Overview'));
	overviews.forEach(overview => {
		Array.from(overview.querySelectorAll('.Item')).forEach(function (item) {
			const link = item.querySelector('nav a, a');
			if (link && !item.classList.contains('useHand')) {
				item.classList.add('useHand');
				item.addEventListener('click', function (e) {
					if (!e.target.closest('a')) {
						window.open(link.href, link.target || '_self');
					}
				});
			}
		});
	});
}
document.addEventListener('DOMContentLoaded', initClickableOverviewItems);
// Re-run for rows appended after load (search load-more dispatches this);
// the .useHand guard keeps already-wired items untouched.
document.addEventListener('ibizz:content', initClickableOverviewItems);
